import { call, put, takeLatest, select } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchMapShifts,
    mapShiftsFetched,
    mapShiftsFetchFailed,
    fetchShiftContext,
    shiftContextFetched,
    shiftContextFetchFailed,
    getMapFilters,
} from '../map';
import { showToastAction } from '../ui';

function* fetchMapShiftsEffect() {
    try {
        const filters = yield select(getMapFilters);
        const queryParams = {};
        if (filters.province) queryParams.province = filters.province;
        if (filters.skill) queryParams.skill = filters.skill;
        if (!filters.showFilled) queryParams.unfilledOnly = 'true';

        const response = yield call(SendApiRequest, {
            url: apiRoutes.mapShifts,
            method: 'GET',
            queryParams,
        });
        yield put(mapShiftsFetched(response));
    } catch (e) {
        yield put(mapShiftsFetchFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: 'Failed to load shifts for map',
            }),
        );
    }
}

function* fetchShiftContextEffect({ payload }) {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.mapShiftContext(payload.shiftId),
            method: 'GET',
        });
        yield put(shiftContextFetched(response));
    } catch (e) {
        yield put(shiftContextFetchFailed());
        yield put(
            showToastAction({
                type: 'danger',
                text: 'Failed to load shift details',
            }),
        );
    }
}

export const mapSagas = [
    takeLatest(fetchMapShifts.type, fetchMapShiftsEffect),
    takeLatest(fetchShiftContext.type, fetchShiftContextEffect),
];
